import { NavLink } from "react-router-dom";
import { DropdownProps } from "../../types/app";

const DropDownMenu = ({ show }: DropdownProps) => {
  return (
    <>
      {show && (
        <div className=" ">
          <div className="absolute -right-20 mt-2 w-[400px] bg-white z-10 border rounded-lg p-4 space-y-6">
            <NavLink
              to="/agent-app"
              style={({ isActive }) => ({
                color: isActive ? "#7F3DFF" : "#d00",
                fontWeight: isActive ? "600" : "400",
                backgroundColor: isActive ? "rgb(206 220 245)" : "",
              })}
            >
              <div className="hover:bg-accent duration-500 hover:bg-opacity-30 rounded-lg p-3">
                <h2 className="text-primaryBlack">Agent App</h2>
                <span className="text-paragraph font-normal">
                  Streamlines transportation and logistics
                </span>
              </div>
            </NavLink>
            <NavLink
              to="/users-app"
              style={({ isActive }) => ({
                color: isActive ? "#7F3DFF" : "#d00",
                fontWeight: isActive ? "600" : "400",
                backgroundColor: isActive ? "rgb(206 220 245)" : "",
              })}
            >
              <div className="hover:bg-accent duration-500 hover:bg-opacity-30 rounded-lg p-3">
                <h2 className="text-primaryBlack">Users App</h2>
                <span className="text-paragraph font-normal">
                  Effortlessly manage your transportation and logistics
                </span>
              </div>
            </NavLink>
          </div>
        </div>
      )}
    </>
  );
};

export default DropDownMenu;
